module.exports = __webpack_public_path__ + "static/img/LogoPMS.0effeb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/LogoPMS.png
// module id = FiMJ
// module chunks = 15